import { Timestamp } from "firebase/firestore";
import { InvestorPortal } from "../types/InvestorPortal";

const PortalsBySubdomain: Record<string, InvestorPortal> = {
  "founders-inc": {
    id: "founders-inc",
    name: "Founders, Inc",
    description: `This is the space I dreamed of having when I was 18 — just tinkering, exploring, and building things with friends, fueled by curiosity and passion. A place where we could experiment freely, supported by a community of people who deeply believed in us. That's exactly what we've built at Founders Inc.`,
    urlIdentifier: "founders-inc",
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
    createdBy: "system",
    firm: {
      name: "Founders, Inc",
      website: "https://f.inc",
    },
    fontFamily: `"Instrument Sans", "Instrument Sans Placeholder", sans-serif`,
  },
};

export async function getInvestorPortalBySubdomain(subdomain: string) {
  if (!subdomain || subdomain === "www") {
    return null;
  }

  return PortalsBySubdomain[subdomain] ?? null;
}
